export default __webpack_public_path__ + "static/media/learose2-1024w.67ea78d5.png";